export default __webpack_public_path__ + "static/041-7d06e39688931f329b940b55556656d6.png";